import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme);
  const ex1 = await getThemePic(data?.customTheme, "ex-1");

  return {
    id: id,
    elements: [
      {
        type: "image",
        id: "qtvFOGiz_D",
        src: ex1,
        width: 205.52,
        height: 233.02,
        left: 101.16251660434226,
        top: 101.54741697828877,
        fixedRatio: true,
        rotate: 113,
        flipH: true,
        flipV: false,
      },
      {
        type: "text",
        id: "Bw7ehCV4dt",
        width: 220.81,
        height: 110.71875,
        left: 227.95387453256686,
        top: 126.78089300664173,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        content:
          '<p style=""><span style="font-size: 48.98px;"><span style="font-family: 幼圆;"><span style="color: #55B577;">目录</span></span></span></p><p style=""><span style="font-size: 36.73px;"><span style="font-family: 幼圆;"><span style="color: rgb(150, 150, 150);">contents</span></span></span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "V33g5l5bYX",
        width: 490.77028871391076,
        height: 190,
        left: 468.38435695538055,
        top: 200.3059317585302,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
    ],

    background,
  };
}
